import { render, staticRenderFns } from "./dynamicColumns.vue?vue&type=template&id=00b656ea&scoped=true"
import script from "./dynamicColumns.vue?vue&type=script&lang=js"
export * from "./dynamicColumns.vue?vue&type=script&lang=js"
import style0 from "./dynamicColumns.vue?vue&type=style&index=0&id=00b656ea&prod&scoped=true&lang=css"
import style1 from "./dynamicColumns.vue?vue&type=style&index=1&id=00b656ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b656ea",
  null
  
)

export default component.exports